/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect } from 'react';
import './referal.css';
import { Button } from '@mui/material';
import { GrLocation } from 'react-icons/gr';
import { AiOutlinePhone } from 'react-icons/ai';
import axios from 'axios';
import mayur from '../../assests/mayur.png';
import Loader from '../Loader';

function ThankSinglePage({
  fullName, baseURL, contactid, linkid, newContactId, 
}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (newContactId?.length > 0) {
      getThankRefer();
    }
  },[newContactId]);

  const getThankRefer = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${baseURL}/testing/get-thank-refer/${linkid}/${contactid}/${newContactId}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',         
        },
      });
      console.log('getTahnkRefer res', res);
      if (res.data.status === 'success') {
        setData(res?.data?.data);
      }
    } catch (err) {
      console.log('getTahnkRefer err', err);
    } finally {
      setLoading(false);
    }
  };
  if (loading) {
    return <Loader />;
  }
  return (
    <div>   
      <div className="qs-page">
        <div className="qs-card">
          <div className="qs-card-body">
            <div className="space-y-2">
              <div className="text-lg font-semibold tracking-tight text-slate-900">{data?.name}</div>
              {data?.full_address !== null && (
                <div className="flex items-start gap-2 text-sm text-slate-500">
                  <span className="mt-0.5 shrink-0 opacity-70"><GrLocation /></span>
                  <span>
                    {data?.full_address}
                  </span>            
                </div>
              )}
                  
              {data?.phone !== null && (
                <div className="flex items-center gap-2 text-sm text-slate-500">
                  <span className="shrink-0 opacity-70"><AiOutlinePhone /></span>
                  <span>
                    {data?.phone}
                  </span>            
                </div>
              )}   
            </div>

            <div className="mt-6 flex justify-center">
              <figure>
                {data?.referral_image?.length > 0 && (
                  <img src={data.referral_image} alt="logo" className="w-[250px] max-w-full rounded-2xl shadow-md ring-1 ring-black/5" />
                )}                
              </figure>
            </div>
            <div className="qs-fade-in mt-6 w-full space-y-2 text-center">
              <h1 className="qs-title">{data?.referral_from_thank_you_page_heading}</h1>
              <div className="qs-subtitle">
                {data?.referral_from_thank_you_page_body}
              </div>
            </div>
          </div>
        </div>
      </div>    
     
    </div>       
        
  );
}

export default ThankSinglePage;
